import {HttpClient} from '@angular/common/http';
import {inject, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';
import {environment} from "../../environments/environment";
import {ResponseData} from "../models/response-data";

export abstract class BaseService {
  apiUrl: string;
  main = 'main';

  protected constructor(protected httpClient: HttpClient, private controller: string) {
    // SSR runs on the same machine as the API — calling the public domain during server render
    // round-trips through Cloudflare for no reason (measured: ~620ms vs ~7ms direct to
    // localhost). Only the browser needs the public URL; Node talks to the API directly.
    const platformId = inject(PLATFORM_ID);
    this.apiUrl = isPlatformServer(platformId)
      ? (typeof process !== 'undefined' && process.env['API_URL']) || 'http://localhost:8000'
      : environment.apiUrl;
  }

  detailBySlug(slug: string) {
    const url = `${this.apiUrl}/api/${this.main}/${this.controller}/detail-by-slug/${slug}`;
    return this.httpClient.get<ResponseData>(url).toPromise();
  }

  searchPage(body: any) {
    const url = `${this.apiUrl}/api/${this.main}/${this.controller}/search-page`;
    return this.httpClient.post<ResponseData>(url, body).toPromise();
  }

  searchList(body: any) {
    const url = `${this.apiUrl}/api/${this.main}/${this.controller}/search-list`;
    return this.httpClient.post<ResponseData>(url, body).toPromise();
  }
}
